/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, weeks: NonNullable<unknown> }} Membership_Freeze_PreviewInputs */

const fr_membership_freeze_preview = /** @type {(inputs: Membership_Freeze_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reprise le ${i?.date}. Votre prochain prélèvement sera décalé de ${i?.weeks} semaine(s).`)
};

/**

* @param {Membership_Freeze_PreviewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_preview = /** @type {((inputs: Membership_Freeze_PreviewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_PreviewInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_preview(inputs)
});